module.exports = __webpack_public_path__ + "img/surveyManagement.87072025.svg";